import React from 'react';
import PropTypes from 'prop-types';
import isEnterOrSpace from '../../helpers/isEnterOrSpace';
import animateScroll from '../../helpers/animateScroll';


const AnchorLink = ({
  className,
  children,
  href,
}) => {
  const handleAnchorClick = (event) => {
    event.preventDefault();
    const targetOffset = document.querySelector(href).offsetTop;

    animateScroll(targetOffset);
  };

  return (
    <a
      href={href}
      tabIndex={0}
      rel="noopener noreferrer"
      className={`link-wrapper link-wrapper--scroll ${className}`}
      onClick={event => handleAnchorClick(event)}
      onKeyPress={event => isEnterOrSpace(event) && handleAnchorClick(event)}
    >
      {children}
    </a>
  );
};

AnchorLink.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  href: PropTypes.string.isRequired,
};

export default AnchorLink;
